import { useEffect } from "react";
import "./WebflowPage.css";

const PAGE_TITLE = "Unofficial Kaws";
const WEBFLOW_PAGE_URL =
  "/webflow-assets/unofficial-kaws.webflow.io/index.html";

function WebflowPage() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = PAGE_TITLE;

    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <main className="webflow-route">
      <iframe
        className="webflow-route__frame"
        src={WEBFLOW_PAGE_URL}
        title={PAGE_TITLE}
      />
    </main>
  );
}

export default WebflowPage;
